module.exports = "/images/icon_arrow_03_04.png?2ad60fbfc94ef51bb5931f7ee47344e9";